import React, { FC, Key, useEffect, useState } from 'react'
import './LoanAdminDetails.scss'
import { useParams } from 'react-router-dom'
import loanService from 'Services/loanServices'
import { loanType } from 'Models/loanType'
import { CurrencyFormatter } from 'Helpers'
import Swal from 'sweetalert2'
import { useSelector } from 'react-redux'
import { useAuth } from 'Components/AuthProvider/AuthProvider'

const LoanAdminDetails: FC<{ isEmployee: boolean }> = ({ isEmployee }) => {
  const { loanId } = useParams<{ loanId: string }>()
  const [loan, setLoan] = useState<loanType>()

  const role = useSelector((state: any) => state.role)
  const { user } = useAuth()
  const isFinance = role === 'finance' || user?.role === 'finance' ? true : false

  const getLoan = async () => {
    await loanService.getSingleLoan(loanId, 1).then(
      (res) => {
        setLoan(res.data.data.dataset[0])
        // console.log('single loan', res.data.data.dataset[0])
      },
      (error) => {
        console.log('productService error', error.response)
      },
    )
  }

  useEffect(() => {
    getLoan()
  }, [loanId])

  // console.log('loan', loan)

  const approveLoan = async (loanId: string, isFinance: boolean) => {
    // console.log(`Approving loan with ID: ${loanId}`)
    await loanService.approval(loanId, isFinance).then(
      () => {
        Swal.fire({
          icon: 'success',
          title: 'Done!',
          text: 'Loan approval succesful',
          showConfirmButton: false,
          timer: 3000,
        })
      },
      (error: { response: { data: { error: string } } }) => {
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  const disapproveLoan = async (loanId: string) => {
    // console.log(`Disapproving loan with ID: ${loanId}`)
    await loanService.reject(loanId).then(
      () => {
        Swal.fire({
          icon: 'success',
          title: 'Done!',
          text: 'Loan rejected succesful',
          showConfirmButton: false,
          timer: 3000,
        })
      },
      (error: { response: { data: { error: string } } }) => {
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  const handleApproval = async (isApproved: boolean) => {
    try {
      const action = isApproved ? 'approve' : 'disapprove'
      const confirmation = window.confirm(`Are you sure you want to ${action} this loan?`)

      if (!confirmation || !loan) return

      if (isApproved) {
        await approveLoan(loan.id, isFinance)
        alert('Loan has been approved')
      } else {
        await disapproveLoan(loan.id)
        alert('Loan has been disapproved')
      }

      window.location.reload()
    } catch (error: any) {
      if (
        error.code === 'ERR_NETWORK' ||
        error.message?.includes('Network Error') ||
        error?.response
      ) {
        console.log('error1')
        alert('Loan has been approved')
      } else {
        console.log('error2 valid')
        alert('Loan has been approved')
      }
      console.error('Error3', error)
      window.location.reload()
    }
  }

  const clearUserLoan = async (loanId: string) => {
    // console.log(`Approving loan with ID: ${loanId}`)
    await loanService.clearUserLoan(loanId).then(
      (res) => {
        Swal.fire({
          icon: 'success',
          title: 'Done!',
          text: 'Loan cleared successfully',
          showConfirmButton: false,
          timer: 3000,
        })
      },
      (error: { response: { data: { error: string } } }) => {
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }
  const handleClearLoan = async () => {
    try {
      // const action = isApproved ? 'approve' : 'disapprove'
      const confirmation = window.confirm('Are you sure you want to clear this loan?')

      if (!confirmation || !loan) return
      await clearUserLoan(loan.id)
      // window.location.reload()
    } catch (error: any) {
      if (
        error.code === 'ERR_NETWORK' ||
        error.message?.includes('Network Error') ||
        error?.response
      ) {
        console.log('error1')
        alert('Loan has been approved')
      } else {
        console.log('error2 valid')
        alert('Loan has been approved')
      }
      console.error('Error3', error)
      window.location.reload()
    }
  }

  const [loanPayments, setLoanPayments] = useState<
    Array<{
      id: string
      loanApplicationId: string
      amountPaid: number
      repaymentDueDate: string
      status: string
    }>
  >()

  const getLoanPayments = async () => {
    await loanService.getLoanPayment(loan?.id).then(
      (response) => {
        // console.log('getLoanPayment', response.data.data)
        setLoanPayments(response.data.data)
      },
      (error) => {
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  useEffect(() => {
    if (loan) {
      getLoanPayments()
    }
  }, [loan])

  return (
    <div className='LoanAdminDetails'>
      <div className='container mt-4'>
        <div className='container'>
          <div className='card shadow-sm border-0 rounded'>
            <div className='card-header bg-default text-dark d-flex justify-content-between align-items-center'>
              <h5 className='mb-0'>Loan Details</h5>
              {!isEmployee && (
                <div>
                  {loan?.financeApprovalStatus === 'PENDING_FINANCE_APPROVAL' &&
                  loan.status === 'PENDING_APPROVAL' &&
                  ['finance'].includes(role || user?.role) ? (
                    <button className='btn btn-success me-2' onClick={() => handleApproval(true)}>
                      Approve
                    </button>
                  ) : loan?.financeApprovalStatus === 'APPROVED' &&
                    loan.status === 'PENDING_APPROVAL' &&
                    ['management'].includes(role || user?.role) ? (
                    <button className='btn btn-success me-2' onClick={() => handleApproval(true)}>
                      Approve
                    </button>
                  ) : (
                    ''
                  )}

                  {['finance', 'management'].includes(role || user?.role) &&
                    (loan?.status === 'REJECTED' ||
                    loan?.status === 'APPROVED' ||
                    loan?.status === 'COMPLETED_REPAYMENT' ? (
                      ''
                    ) : (
                      <button className='btn btn-danger' onClick={() => handleApproval(false)}>
                        Disapprove
                      </button>
                    ))}
                  <button className='btn btn-warning text-white' onClick={() => handleClearLoan()}>
                    Clear Loan
                  </button>
                </div>
              )}
            </div>
            <div className='card-body p-4'>
              <div className='row'>
                <div className='col-md-6'>
                  <p>
                    <strong>Loan Amount:</strong> ₦{CurrencyFormatter(loan?.amount ?? 0)}
                  </p>
                  <p>
                    <strong>Approved At:</strong> {loan?.approvedAt}
                  </p>
                  <p>
                    <strong>Approved By:</strong> {loan?.approvedBy}
                  </p>
                  <p>
                    <strong>Created At:</strong> {loan?.createdAt}
                  </p>
                  <p>
                    <strong>Loan ID:</strong> {loan?.id}
                  </p>
                </div>
                <div className='col-md-6'>
                  <p>
                    <strong>Monthly Repayment:</strong> ₦
                    {CurrencyFormatter(Number(loan?.monthlyRepaymentAmount) ?? 0)}
                  </p>
                  <p>
                    <strong>Purpose:</strong> {loan?.purpose}
                  </p>
                  <p>
                    <strong>Repayment Duration:</strong> {loan?.repaymentDurationInMonths} months
                  </p>
                  {!isEmployee ? (
                    <p>
                      <strong>Status:</strong>
                      <span
                        className={`badge ${
                          loan?.status === 'REJECTED'
                            ? 'bg-danger fw-bold'
                            : loan?.status === 'COMPLETED_REPAYMENT'
                              ? 'bg-success fw-bold'
                              : loan?.financeApprovalStatus === 'PENDING_FINANCE_APPROVAL' ||
                                  loan?.status === 'PENDING_APPROVAL'
                                ? 'bg-warning fw-bold'
                                : loan?.status === 'APPROVED'
                                  ? 'bg-success fw-bold'
                                  : 'bg-success fw-bold'
                        }
                      `}
                        // className={`badge ${loan?.status === 'APPROVED' ? 'bg-success' : 'bg-warning'} ms-2`}
                      >
                        {loan?.status === 'REJECTED'
                          ? 'Rejected'
                          : loan?.status === 'COMPLETED_REPAYMENT'
                            ? 'Completed Repayment'
                            : loan?.financeApprovalStatus === 'PENDING_FINANCE_APPROVAL'
                              ? 'Pending Finance Approval'
                              : loan?.financeApprovalStatus === 'APPROVED' &&
                                  loan?.status === 'PENDING_APPROVAL'
                                ? 'Pending Management Approval'
                                : loan?.status === 'APPROVED'
                                  ? 'Approved'
                                  : loan?.status}
                      </span>
                    </p>
                  ) : (
                    <p>
                      <strong>Status:</strong>
                      <span
                        className={`badge ${
                          loan?.status === 'REJECTED'
                            ? 'bg-danger fw-bold'
                            : loan?.status === 'COMPLETED_REPAYMENT'
                              ? 'bg-success fw-bold'
                              : loan?.status === 'APPROVED'
                                ? 'bg-success fw-bold'
                                : loan?.status === 'PENDING_APPROVAL'
                                  ? 'bg-orange fw-bold'
                                  : 'bg-success fw-bold'
                        }`}
                        // className={`badge ${loan?.status === 'APPROVED' ? 'bg-success' : 'bg-warning'} ms-2`}
                      >
                        {loan?.status === 'REJECTED'
                          ? 'Rejected'
                          : loan?.status === 'COMPLETED_REPAYMENT'
                            ? 'Completed Repayment'
                            : loan?.status === 'PENDING_APPROVAL'
                              ? 'Pending Approval'
                              : loan?.status === 'APPROVED'
                                ? 'Approved'
                                : loan?.status}
                      </span>
                    </p>
                  )}

                  <p>
                    <strong>Updated At:</strong> {loan?.updatedAt}
                  </p>
                </div>
              </div>
              <hr />
              <h6 className='text-dark '>User Information</h6>
              <div className='row mt-4'>
                <div className='col-md-6'>
                  <p>
                    <strong>Name:</strong> {loan?.user?.firstName} {loan?.user?.lastName}
                  </p>
                </div>
                <div className='col-md-6'>
                  <p>
                    <strong>Email:</strong> {loan?.user?.emailAddress}
                  </p>
                  <p>
                    <strong>Phone:</strong> {loan?.user?.msisdn}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className='card mt-4 mb-5'>
            <div className='card-header fw-bold'>Repayment Overview</div>
            <div className='card-body'>
              <div className='table-responsive'>
                <table className='table'>
                  <thead className='fw-bolder'>
                    <tr>
                      <td>#</td>
                      <td>ID</td>
                      <td>Amount Paid</td>
                      <td>Loan Application Id</td>
                      <td>RepaymentDueDate</td>
                      <td>Status</td>
                    </tr>
                  </thead>
                  <tbody>
                    {loanPayments &&
                      loanPayments.length > 0 &&
                      loanPayments.map((lp, index: Key) => {
                        return (
                          <tr key={index}>
                            <td>{Number(index) + 1}</td>
                            <td>{lp.id}</td>
                            <td>₦{CurrencyFormatter(lp.amountPaid)}</td>
                            <td>{lp.loanApplicationId}</td>
                            <td>{lp.repaymentDueDate}</td>
                            <td
                              className={`badge ${lp?.status === 'PAID' ? 'bg-success' : 'bg-warning'} text-white mt-2`}
                            >
                              {lp.status}
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoanAdminDetails
